import { appConstants, authConstants } from "../_constants";
import { authService } from "../_services";
import { alertActions } from "./";
import { appHelpers, history } from "../_helpers";

function login(username, password) {
  return (dispatch) => {
    dispatch(request({ username }));

    return authService.login(username, password).then(
      (user) => {
        if (user.error == null) {
          dispatch(success(user));
          console.log(user, "AVIUSER");

          /*Check status of user */
          const userRole = appHelpers.interpretRole(user);
          let userBasePage = "/";
          if (
            userRole === appConstants.ROLES.AIRLINE_ADMIN ||
            userRole === appConstants.ROLES.AIRLINE_STAFF ||
            userRole === appConstants.ROLES.STAFF
          ) {
            userBasePage = "/search";
          }

          if (user.EmailDomainRequired) {
            let redirectUrl = window.location.origin + userBasePage;
            const url_ = `${appConstants.EMAIL_DOMAIN_URL}${user.access_token}&redirecturl=${redirectUrl}`;
            window.open(url_, "_self");
          } else if (user.ForcePasswordChange) {
            const url_ = appConstants.RESET_PASSWORD_URL + user.access_token;
            window.open(url_, "_self");
          } else {
            history.push(userBasePage);
          }
        } else {
          dispatch(alertActions.error(user.error_description));
          dispatch(failure(user));
        }
      },
      (error) => {
        const errMessage = appHelpers.interpretErrorResponse(error);
        dispatch(alertActions.error(errMessage));
        dispatch(failure(error));
      }
    );
  };

  function request(user) {
    return { type: authConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: authConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: authConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  authService.logout();
  return { type: authConstants.LOGOUT };
}

export const authActions = {
  login,
  logout,
};



// WEBPACK FOOTER //
// ./src/_actions/auth.actions.js